define([
	"dojo/_base/lang",
	"dojo/Deferred",
	"dojo/store/util/QueryResults"
], function(lang,Deferred,QueryResults) {

	return {
		addDojoStoreAPI: function(/*dojo.data.api.Read*/store) {
			// summary: add new dojo.store API functions to the old dojo.data store.
			// Copied from dijit/form/ComboBoxMixin
			if(!store || store.get)
				return store;
	
			lang.mixin(store, {
				_oldAPI: true,
				get: function(id){
					// summary:
					//		Retrieves an object by it's identity. This will trigger a fetchItemByIdentity.
					//		Like dojo.store.DataStore.get() except returns native item.
					var deferred = new Deferred();
					this.fetchItemByIdentity({
						identity: id,
						onItem: function(object){
							deferred.resolve(object);
						},
						onError: function(error){
							deferred.reject(error);
						}
					});
					return deferred.promise;
				},
				query: function(query, options){
					// summary:
					//		Queries the store for objects.   Like dojo.store.DataStore.query()
					//		except returned Deferred contains array of native items.
					var deferred = new Deferred(function(){ fetchHandle.abort && fetchHandle.abort(); });
					var	qr = QueryResults(deferred);
					
					var fetchHandle = this.fetch(lang.mixin({
						query: query,
						onBegin: function(count){
							qr.total = count;
						},
						onComplete: function(results){
							deferred.resolve(results);
						},
						onError: function(error){
							deferred.reject(error);
						}
					}, options));

					return qr;
				}
			});
			
			return store;
		}
	};
});